<template>
  <div class="prize-container">
    <div class="p-top">
      <div class="t-left">累计投票得好礼</div>
      <div class="t-right">已投票{{ voteNum }}张</div>
    </div>
    <div class="prize-list">
      <div
        class="prize-item"
        v-for="(item, index) in data"
        @click="bindClick(item)"
        :class="{
          'prize-item-active': item.reach_type || item.received_status,
          'prize-item-animate': item.reach_type
        }"
        :key="index"
      >
        <div class="item-num">{{ item.require_vote_num }}票</div>
        <div class="item-icon">
          <img class="item-image" :src="item.reward_image_url" alt="" />
        </div>
        <div class="item-name">{{ item.reward_name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    voteNum: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      defalut: () => []
    }
  },
  data() {
    return {
      bindClick(item) {
        this.$emit('preview', item)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.prize-container {
  padding: 14px 18px;
  box-sizing: border-box;
  height: 136px;
  border-radius: 10px;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d85bf992bb255288b5411175a98d2573.png');
  background-size: 100%;
  background-repeat: no-repeat;

  .p-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 11px;

    .t-left {
      font-size: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #965d3a;
      line-height: 20px;
    }

    .t-right {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #965d3a;
      line-height: 20px;
    }
  }

  .prize-list {
    display: flex;
    align-items: center;
    justify-content: space-around;

    .prize-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      .item-num {
        padding: 0px 6px;
        min-width: 38px;
        height: 16px;
        background: #555555;
        border-radius: 8px;
        line-height: 16px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        text-align: center;
        color: #ffffff;
        position: relative;
        z-index: 1;
      }

      .item-icon {
        margin-top: -8px;
        width: 48px;
        height: 48px;
        box-sizing: border-box;
        background: #ffffff;
        border: 3px solid #ffffff;
        box-shadow: 0px 2px 4px 0px rgba(207, 123, 95, 0.5);
        border-radius: 24px;
        margin-bottom: 4px;
        position: relative;

        .item-image {
          object-fit: contain;
          border-radius: 50%;
          overflow: hidden;
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        }
      }

      .item-name {
        white-space: nowrap;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%, 100%);
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(156, 85, 54, 0.8);
        line-height: 16px;
      }
    }

    .prize-item:nth-child(2) {
      transform: translateY(5px);
    }

    .prize-item-active {
      .item-num {
        background: #ff774b;
      }

      .item-icon {
        border: 3px solid #ff774b;
      }
    }

    /* .prize-item-animate {
            .item-icon {
                animation: myScale 1s linear infinite;
            }

            .item-num {
                animation: myScale 1s linear infinite;
            }
        } */
  }
}

@keyframes myScale {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.05);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
  }
}
</style>
